export const nav = {
  dashboard: 'Dashboard',
  customers: 'Customers',
  customerRelationshipLogs: 'Relationship Logs',
  products: 'Products',
  offers: 'Offers',
  contracts: 'Contracts',
  templates: 'Templates',
  documentStorage: 'Document Storage',
  deals: 'Deals',
  reports: 'Reports',
  settings: 'Settings',
  profile: 'Profile',
  system_admin: 'System admin',
  workPagesTemplates: 'Workpage templates',
  filledWorkpage: 'Filled workpage',
  organization: 'Organization',
  selectOrganization: 'Select organization',
  // Groups
  groups: {
    crm: 'CRM & Sales',
    products: 'Products & Documents',
    documents: 'Documents',
    energia: 'Electricity'
  },
  // Energy Management menu items
  energia_dashboard: 'Energy Dashboard',
  energia_pods: 'Energy PODs',
  consumption_locations: 'Consumption Locations',
  energia_contracts: 'Energy Contracts',
  energia_products: 'Energy Products',
  bulk_invoice_manager: 'Bulk Invoicing',
  energia_billing: 'Energy Billing',
  energia_analytics: 'Energy Analytics',
  energia_monitoring: 'Energy Monitoring',
  energia_utilmd: 'Energy UTILMD',
  mscons_readings: 'MSCONS Readings'
}